// extracted by mini-css-extract-plugin
export default {"container":"WorkbenchSentimentSelect__container___4T6Pg"};